import { render, staticRenderFns } from "./Reliability.vue?vue&type=template&id=2b73abb6&scoped=true"
import script from "./Reliability.vue?vue&type=script&lang=js"
export * from "./Reliability.vue?vue&type=script&lang=js"
import style0 from "./Reliability.vue?vue&type=style&index=0&id=2b73abb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b73abb6",
  null
  
)

export default component.exports